import React, { useEffect } from "react";
import ax from "../../utils/ax";
import InfoSidebar from "./InfoSidebar/InfoSidebar";
import Streams from "./Streams/Streams";
import CommandSidebar from "./CommandSidebar/CommandSidebar";
import ChatSidebar, { ChatFAB } from "./ChatSidebar/ChatSidebar";
import FadeDiv from "../FadeDiv/FadeDiv";
import { useRecoilValue } from "recoil";
import listState from "../../recoil/atoms/list";
import { useNavigate, useLocation } from "react-router-dom";
import apiBaseURL from "../../utils/apiBaseURL";
import * as userStore from "../../recoil/atoms/user"
import { useState } from "react";

function Experiment({ experimentID }) {
	const navigate = useNavigate();
	const location = useLocation();
	const currExp = useRecoilValue(listState);
	const [isChatOpen, setIsChatOpen] = useState(false);
	
	// Check offline mode from Recoil state (preferred) or URL params (backwards compatibility)
	const params = new URLSearchParams(location.search);
	const offlineFromURL = params.get("offline") === "1";
	const offlineFromState = currExp.offlineMode === true;
	const offlineView = offlineFromURL || offlineFromState;
	
	console.log("Experiment component - offlineView:", offlineView, "from Recoil:", offlineFromState, "from URL:", offlineFromURL, "currExp:", currExp);

	const user = useRecoilValue(userStore.state);

	const [state, setState] = useState(false);

	const getCurrentDate = () => {
		const currentDate = new Date();
		const year = currentDate.getFullYear();
		const month = String(currentDate.getMonth() + 1).padStart(2, "0");
		const day = String(currentDate.getDate()).padStart(2, "0");
		return `${day}-${month}-${year}`;
	};

	const checkSlot = () => {
		console.log("getting into it", experimentID, "offlineView:", offlineView);
		// Skip slot check in offline mode
		if (offlineView) {
			console.log("Skipping slot check - offline mode");
			setState(true);
			return;
		}
		
		const todayDate = getCurrentDate();
		ax.post(apiBaseURL + "/checkUserSlot", {
			userId: user._id,
			experimentID: currExp.experimentID,
			date: todayDate
		})
		.then((res) => res.data)
		.then((data) => {
			if(data){
				setState(true)
			} else {
				setState(true)

				// setCurrExp({ experimentID: -1 })
				
				// if(rendered===1){
				// message.open({
				// 	type: 'warning',
				// 	content: "You have not booked any slot for the current time",
					
				//   });
				//   rendered=0;
				// } else {rendered++}
				
			}
		})
	}

	useEffect(() => {
		// If not offlineView and experiment is not set or slot not allowed, redirect
		if (!offlineView && currExp.experimentID === -1) navigate("/");
	}, [currExp, navigate, offlineView]);

	useEffect(() => {
		// Only check slot once when component mounts (and not in offline mode)
		if (!offlineView) {
			checkSlot();
		} else {
			// In offline mode, set state to true immediately
			setState(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


		// If offlineView is enabled we still render layout but show offline streams
		const shouldRender = offlineView ? true : (currExp.experimentID !== -1 && state);

	return (
		shouldRender && (
		<FadeDiv className="h-full w-full">
			<div className="relative flex min-h-full flex-col">
				<div className="mx-auto flex w-full flex-grow justify-between lg:flex xl:px-8">
					{/* Left sidebar */}
					<InfoSidebar experimentID={experimentID} />

					{offlineView ? (
						<Streams experimentID={experimentID} offline="true" />
					) : (
						<Streams experimentID={experimentID} />
					)}

					<CommandSidebar experimentID={experimentID} offline={offlineView} />
				</div>
			</div>
			
			{/* Floating Action Button to open chat */}
			<ChatFAB onClick={() => setIsChatOpen(true)} />
			
			{/* Chat Modal */}
			<ChatSidebar 
				experimentID={experimentID} 
				isOpen={isChatOpen}
				onClose={() => setIsChatOpen(false)}
			/>
			
			{/* Right side background filler */}
			<div
				className="fixed top-0 right-0 h-full w-8 bg-gray-50"
				aria-hidden="true"
			/>
		</FadeDiv>
		)
	);
}

export default Experiment;
